/**
 * Collapsible fieldset companion.
 *
 * `.collapsible-fieldset__content` keeps `overflow: hidden` so the height animation clips the
 * sliding content, but that also traps inner dropdowns (autocomplete suggestions, selects) once the
 * section is open. We drop the clip as soon as the open transition ends, and restore it the moment
 * closing starts so the collapse still hides the content. Delegated on `document` so it works on
 * both controller pages and LiveViews.
 */
const FIELDSET = ".collapsible-fieldset";
const CONTENT = ".collapsible-fieldset__content";
const LEGEND_CHECKBOX = ".collapsible-fieldset__legend .checkbox";
const OVERFLOW_VISIBLE = "collapsible-fieldset__content--overflow-visible";

function legendCheckbox(fieldset) {
  return fieldset?.querySelector(LEGEND_CHECKBOX);
}

// Reveal overflow exactly when the open (height) transition ends.
document.addEventListener("transitionend", (event) => {
  const content = event.target;
  if (event.propertyName !== "height" || !content.matches?.(CONTENT)) return;

  const checkbox = legendCheckbox(content.closest(FIELDSET));
  content.classList.toggle(OVERFLOW_VISIBLE, Boolean(checkbox?.checked));
});

// Re-clip as soon as closing starts so the collapse animation hides the content.
document.addEventListener("change", (event) => {
  const checkbox = event.target;
  if (!checkbox.matches?.(LEGEND_CHECKBOX) || checkbox.checked) return;

  checkbox.closest(FIELDSET)?.querySelector(CONTENT)?.classList.remove(OVERFLOW_VISIBLE);
});

// A fieldset rendered already open never animates, so reveal it on load.
function revealInitiallyOpen() {
  document.querySelectorAll(FIELDSET).forEach((fieldset) => {
    if (legendCheckbox(fieldset)?.checked) {
      fieldset.querySelector(CONTENT)?.classList.add(OVERFLOW_VISIBLE);
    }
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", revealInitiallyOpen);
} else {
  revealInitiallyOpen();
}
